import RedirectUrl from "./RedirectUrl";

export default RedirectUrl;